import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Camera, Trash2, ImageOff } from "lucide-react";

export default function ParcelPhotos({ parcelleId }) {
  const { t } = useI18n();
  const [photos, setPhotos] = useState([]);
  const [uploading, setUploading] = useState(false);
  const token = () => localStorage.getItem("agrinova_token") || "";
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  async function load() {
    try {
      const r = await api.get(`/parcelles/${parcelleId}/photos`);
      setPhotos(r.data);
    } catch { /* ignore */ }
  }
  useEffect(() => { if (parcelleId) load(); }, [parcelleId]);

  async function onFile(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      await api.post(`/parcelles/${parcelleId}/photos`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(t("added"));
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || t("error"));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  }

  async function del(id) {
    if (!window.confirm(t("confirm_delete"))) return;
    await api.delete(`/photos/${id}`);
    toast.success(t("deleted"));
    load();
  }

  return (
    <div className="mt-4 pt-4 border-t border-border/60" data-testid={`photos-section-${parcelleId}`}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs uppercase tracking-widest font-semibold text-muted-foreground flex items-center gap-1.5">
          <Camera className="w-3.5 h-3.5" /> Photos
        </span>
        <label>
          <input type="file" accept="image/*" className="hidden" onChange={onFile} disabled={uploading} data-testid={`photo-input-${parcelleId}`} />
          <Button variant="outline" size="sm" disabled={uploading} asChild data-testid={`photo-add-${parcelleId}`}>
            <span className="cursor-pointer">{uploading ? "…" : `+ ${t("add")}`}</span>
          </Button>
        </label>
      </div>
      {photos.length === 0 ? (
        <div className="text-xs text-muted-foreground flex items-center gap-2 py-2"><ImageOff className="w-3.5 h-3.5" /> {t("no_data")}</div>
      ) : (
        <div className="grid grid-cols-3 gap-2">
          {photos.map((p) => (
            <div key={p.id} className="relative group rounded-lg overflow-hidden border border-border">
              <img
                src={`${API_URL}/api/photos/${p.storage_path}?auth=${token()}`}
                alt={p.caption || p.original_filename}
                className="w-full h-20 object-cover"
                data-testid={`photo-img-${p.id}`}
              />
              <button
                onClick={() => del(p.id)}
                className="absolute top-1 right-1 w-6 h-6 rounded bg-black/60 text-white opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center"
                data-testid={`photo-delete-${p.id}`}
              >
                <Trash2 className="w-3 h-3" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
